var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "modal_wrap" }, on: { click: _vm.onClose } },
    [
      _c("div", { staticClass: "modal_container" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-default closeBtn",
            on: { click: () => _vm.onClose(null) },
          },
          [_c("i", { staticClass: "icon-fa icon-fa-remove" })]
        ),
        _vm._v(" "),
        _vm.modalData?.header
          ? _c("div", { staticClass: "modal_header" }, [
              _c("h4", [_vm._v(_vm._s(_vm.modalData?.header))]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "modal_body" }, [_vm._t("default")], 2),
        _vm._v(" "),
        !_vm.modalData?.disableFooter
          ? _c("div", { staticClass: "modal_footer" }, [
              _c(
                "div",
                { staticClass: "flex justify-content-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      on: { click: () => _vm.onClose(null) },
                    },
                    [_vm._v("Отмена")]
                  ),
                  _vm._v(" "),
                  _c(
                    "vue-ladda",
                    {
                      attrs: {
                        type: "submit",
                        "button-class": "btn btn-success",
                        "data-style": "zoom-in",
                        loading: _vm.acceptBtnLoading,
                      },
                      on: { click: _vm.onAccept },
                    },
                    [_vm._v("Ok\n        ")]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }